<template>
  <div>
    <div class="form_box">

      <div class="bottom_part">

        <div class="info_row">
          <span class="input_description">Добавить город</span>
          <select class="select_tag">
          </select>
        </div>

      </div>
      <button class="menu_item_btn" @click="saveData">СКОПИРОВАТЬ</button>

    </div>
  </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2/dist/css/select2.min.css'
import 'select2'
export default {
  name: 'presents',
  props: ['auth', 'id', 'mapinit', 'user'],
  data () {
    return {
      citys: []
    }
  },
  methods: {
    saveData () {
      var formData = new FormData()
      formData.append('id', this.id)
      formData.append('uid', this.$root.auth.uid)
      formData.append('city_id', this.citys)
      axios.post('https://lk.when-hungry.com/mobile/restaurant-copy',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.data.status === 'error') {
          alert(response.data.text)
        } else {
          setTimeout(() => {
            alert('Рестораны скопированы')
          }, 1)
        }
      })
    },
    initAjax () {
      var self = this
      $('.select_tag').select2({
        width: '100%',
        multiple: true,
        tags: true,
        placeholder: 'Выберите город',
        ajax: {
          url: 'https://lk.when-hungry.com/site/search-city',
          data: (params) => {
            params.id = this.$root.city.country_id
            params.q = params.term
            params.all = 0
            params.country = 1
            params.comm = 1
            return params
          },
          dataType: 'json',
          processResults: function (data) {
            return {
              results: $.map(data, function (key, item) {
                return {
                  text: key,
                  id: item
                }
              })
            }
          }
        }
      }).on('select2:select', function () {
        self.citys = $(this).val()
      })
    }
  },
  mounted () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant/copy.vue